import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

function NewsDetail() {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  // 相关文章推荐
  const relatedArticles = [
    { id: 3, title: '2025年第一季度经济数据点评：复苏动能仍存' },
    { id: 5, title: '美联储利率决议点评及对全球市场的影响' },
    { id: 9, title: '2025年最值得关注的五大行业' }
  ];

  useEffect(() => {
    // 模拟从API获取新闻详情
    setLoading(true);
    setTimeout(() => {
      // 这里仅做示例，实际应用应调用后端API
      const demoArticle = {
        id: parseInt(id),
        title: '央行降准对A股市场的影响分析',
        date: '2025-03-15',
        author: '李分析师',
        category: '政策解读',
        content: `
          <p>3月14日，中国人民银行宣布将下调金融机构存款准备金率0.5个百分点，这是今年首次全面降准。此举预计将释放长期资金约1万亿元，支持实体经济发展。降准消息公布后，市场反应积极，本文将分析此次降准对A股市场的影响。</p>
          
          <h3>一、降准的背景与意义</h3>
          <p>本次降准是在国内经济恢复基础仍需巩固的背景下实施的。当前，国内消费修复进程仍在继续，但投资增速有所放缓，稳增长压力依然存在。同时，外部环境复杂多变，国际贸易和投资合作面临挑战。</p>
          <p>降准旨在进一步增强金融服务实体经济的能力，为市场提供适度充裕的流动性，降低社会融资成本，支持经济高质量发展。</p>
          
          <h3>二、对A股市场的短期影响</h3>
          <p>从短期来看，降准信号向好，将提振市场信心：</p>
          <ol>
            <li><strong>流动性改善</strong>：释放的长期资金有部分会直接或间接流入股市，提供增量资金支持；</li>
            <li><strong>情绪面提振</strong>：政策面支持的信号将改善市场预期，投资者风险偏好或有提升；</li>
            <li><strong>板块效应</strong>：金融、地产、基建等政策敏感性板块可能率先受益，出现估值修复行情。</li>
          </ol>
          
          <h3>三、对A股市场的中长期影响</h3>
          <p>中长期来看，降准对市场的影响将更多取决于：</p>
          <ol>
            <li><strong>实体经济转化效果</strong>：降准资金能否有效支持实体经济，转化为企业盈利增长；</li>
            <li><strong>后续政策组合拳</strong>：货币政策、财政政策、产业政策等是否形成合力；</li>
            <li><strong>内外部环境变化</strong>：国内经济恢复进程及国际市场波动等因素。</li>
          </ol>
          
          <h3>四、投资策略建议</h3>
          <p>基于降准政策及市场环境，投资者可考虑以下策略：</p>
          <ol>
            <li><strong>关注政策受益板块</strong>：金融、地产、基建等直接受益于流动性改善的板块；</li>
            <li><strong>布局高景气赛道</strong>：新能源、人工智能、高端制造等符合国家战略方向的成长板块；</li>
            <li><strong>均衡配置</strong>：适当平衡价值与成长，控制仓位，降低单一板块风险。</li>
          </ol>
          
          <h3>五、风险提示</h3>
          <p>投资者也需警惕以下风险因素：</p>
          <ol>
            <li>降准释放的资金未必直接流入股市；</li>
            <li>美联储政策变化可能引发外部市场波动；</li>
            <li>经济基本面改善仍需时日，业绩支撑仍是关键。</li>
          </ol>
          
          <h3>结论</h3>
          <p>本次降准有助于改善市场流动性和投资者情绪，短期内对A股市场形成支撑。但中长期市场表现仍将取决于经济基本面改善和企业盈利恢复情况。投资者应保持理性，关注政策动向，结合基本面分析制定投资策略。</p>
        `,
        viewCount: 3521,
        tags: ['央行', '降准', 'A股', '流动性', '投资策略']
      };
      setArticle(demoArticle);
      setLoading(false);
    }, 500);
  }, [id]);

  if (loading) {
    return (
      <div className="container" style={{ textAlign: 'center', padding: '50px 0' }}>
        <div>加载中...</div>
      </div>
    );
  }

  if (!article) {
    return (
      <div className="container" style={{ textAlign: 'center', padding: '50px 0' }}>
        <div>未找到文章</div>
      </div>
    );
  }

  return (
    <div className="container">
      {/* 面包屑导航 */}
      <div className="breadcrumbs">
        <Link to="/">首页</Link> <span>&gt;</span> 
        <Link to="/news">资讯</Link> <span>&gt;</span> 
        <span>{article.category}</span>
      </div>

      <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
        {/* 主要内容区 */}
        <div style={{ flex: '1', minWidth: '300px' }}>
          <div className="section-card">
            <div className="section-content" style={{ padding: '30px' }}>
              {/* 文章标题 */}
              <h1 style={{ fontSize: '24px', marginBottom: '20px', fontWeight: '600' }}>
                {article.title}
              </h1>
              
              {/* 文章元信息 */}
              <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                color: '#666', 
                fontSize: '14px',
                marginBottom: '25px',
                borderBottom: '1px solid #e1e4e8',
                paddingBottom: '15px'
              }}>
                <div>
                  <span style={{ marginRight: '15px' }}>作者: {article.author}</span>
                  <span style={{ marginRight: '15px' }}>发布时间: {article.date}</span>
                  <span>分类: {article.category}</span>
                </div>
                <div>
                  <span>阅读: {article.viewCount}</span>
                </div>
              </div>
              
              {/* 文章内容 */}
              <div 
                className="article-content" 
                style={{ lineHeight: '1.8', fontSize: '16px' }}
                dangerouslySetInnerHTML={{ __html: article.content }}
              />
              
              {/* 文章标签 */}
              <div style={{ marginTop: '30px' }}>
                {article.tags.map((tag, index) => (
                  <span key={index} style={{ 
                    display: 'inline-block',
                    padding: '3px 10px',
                    backgroundColor: '#f5f6fa',
                    color: '#1e3a8a',
                    borderRadius: '4px',
                    fontSize: '14px',
                    marginRight: '8px',
                    marginBottom: '8px'
                  }}>
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
        
        {/* 右侧边栏 */}
        <div style={{ width: '280px' }}>
          {/* 相关阅读 */}
          <div className="section-card">
            <div className="section-header" style={{ fontSize: '16px' }}>相关阅读</div>
            <div className="section-content">
              <ul style={{ listStyle: 'none' }}>
                {relatedArticles.map(article => (
                  <li key={article.id} style={{ 
                    padding: '10px 0', 
                    borderBottom: '1px solid #e1e4e8'
                  }}>
                    <Link to={`/news/${article.id}`} style={{ 
                      color: '#333', 
                      textDecoration: 'none',
                      fontSize: '14px'
                    }}>
                      {article.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          
          {/* 热门推荐 */}
          <div className="section-card" style={{ marginTop: '20px' }}>
            <div className="section-header" style={{ fontSize: '16px' }}>热门推荐</div>
            <div className="section-content">
              <div style={{ 
                padding: '10px',
                textAlign: 'center'
              }}>
                <img 
                  src="https://via.placeholder.com/240x150?text=AI诊股" 
                  alt="AI诊股" 
                  style={{ borderRadius: '4px', marginBottom: '10px' }}
                />
                <Link to="/analysis" style={{ 
                  display: 'block',
                  padding: '8px',
                  backgroundColor: '#1e3a8a',
                  color: 'white',
                  textDecoration: 'none',
                  borderRadius: '4px',
                  fontWeight: '500'
                }}>
                  立即体验AI诊股
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewsDetail;
